import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },

  columnGrid: {
    margin: theme.spacing(1, 0, 1, 0),
  },

  publicAccessSection: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(2),
    border: '1px solid #D7E3F0',
    borderRadius: 4,
    backgroundColor: '#F8FBFE',
  },

  publicAccessTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },

  tabEdit:{
    paddingTop: theme.spacing(2),
  }
}));
